// extracted by mini-css-extract-plugin
export default {"button":"Player_button__Pg-d8","activePlayer":"Player_activePlayer__0ezYa"};